import { render, staticRenderFns } from "./FeedbackConfirmationModal.vue?vue&type=template&id=3caa811a&scoped=true"
import script from "./FeedbackConfirmationModal.vue?vue&type=script&lang=js"
export * from "./FeedbackConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./FeedbackConfirmationModal.vue?vue&type=style&index=0&id=3caa811a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caa811a",
  null
  
)

export default component.exports